import { memo, useMemo, useEffect, useState, useCallback, useRef } from 'react'
import { useSearchParams } from "react-router-dom"
import Layout from 'layout/index_v4'
import Question from './components/Question'
// import { createYupSchema } from 'helpers/functions'
import { validationSchema } from 'validations'
// import * as yup from "yup"
import { Form, Formik } from 'formik'
import ResetBtnGroup from './components/ResetBtnGroup'
import NextBtn from './components/NextBtn'
import ResultBtn from './components/ResultBtn'
import GetResultStep from './components/GetResultStep'
import OtherAreaStep from './components/OtherAreaStep'
import MessageModal from './components/MessageModal'
import ThankyouModal from './components/ThankyouModal'
import SignupSuccessModal from './components/SignupSuccessModal'
import Badges from './components/Badges'
// import { useScreening } from 'context'

const Screening = (props) => {
	const { questions, states, lead, signup_url, getCaseQuestions, verifyCase, contactAdmin, qualifiedContent, disqualifiedContent, holdContent } = props
	const [isPageLoading, setIsPageLoading] = useState(false)
	const [showLastStep, setShowLastStep] = useState(false)
	const [showResult, setShowResult] = useState(false)
	const [showOtherAreaStep, setshowOtherAreaStep] = useState(false)
	const [intakeStatus, setIntakeStatus] = useState('DISQUALIFIED')
	const [searchParams, ] = useSearchParams()
	const cid = searchParams.get('cid') || null
	const tpl_id = searchParams.get('tpl_id') || null
	const test_mode = searchParams.get('test_mode') || null
	const gclid = searchParams.get('gclid') || ''
	const fbclid = searchParams.get('fbclid') || ''
	const [form_step, setFormStep] = useState(1)
	const [total_steps, setTotalSteps] = useState(0)
	const [terminateScreening, setTerminateScreening] = useState(false)
	const [openMessageModal, setOpenMessageModal] = useState(false)
	const [openThankyouModal, setOpenThankyouModal] = useState(false)
	const [openSignupSuccessModal, setOpenSignupSuccessModal] = useState(false)
	const [submitSignup, setSubmitSignup] = useState(false)
	const [isStepSkipped, setIsStepSkipped] = useState(false)
	const [initialValues, setInitialValues] = useState({
		'first_name': '',
		'last_name': '',
		'email': '',
		'phone': '',
		'state': 'CA',
		'accident_date': null,
		tnc: false,
	})
	const formikRef = useRef(null)
	const progress_percent = useMemo(() => {
		if(questions.length > 0) {
			return Math.round((form_step/total_steps) * 100) 
		}

		return 0
	}, [form_step, questions.length, total_steps])
	const question = useMemo(() => {
		if(questions.length > 0) {
			return questions.filter((item, index) => ((index + 1) === form_step)).pop()
		}
		return {}
	}, [form_step, questions])

	useEffect(() => {
		if(!cid) return
		setIsPageLoading(true)
		getCaseQuestions({ cid, tpl_id, test_mode }).then(response => {
			setIsPageLoading(false)

			if(response.data.success) {
				setTotalSteps(response.data.questions.length + 2)
				
				response.data.questions.map(item => {
					return setInitialValues(previousValues => {
						let initValue = {}
						if(item.multiselect) {
							initValue[`question-${item.id}`] = []
						} else {
							initValue[`question-${item.id}`] = ''
						}
						return {...previousValues, ...initValue}
					})
				})
			}
		}).catch(error => {
			setIsPageLoading(false)
		})
	}, [setIsPageLoading, getCaseQuestions, searchParams, cid, tpl_id, test_mode])

	const changeStep = useCallback((step, option=null) => {

		if(option) {
			if(option.action === 'skip') {
				setIsStepSkipped(true)

				const skippedQuestion = questions.filter((item, index) => ((index + 1) === (step - 1) )).pop()
				// console.log(skippedQuestion)

				if(formikRef.current) {
					formikRef.current.setFieldValue(`question-${skippedQuestion.id}`, '')	
				}
				
			} else {
				setIsStepSkipped(false)
			}
		}
		
		if(step > questions.length){
			setShowLastStep(true)
			setShowResult(false)
			setFormStep((questions.length + 1))
		} else {
			if((questions.length + 1) === step) {
				setShowLastStep(true)
				setShowResult(false)
			} else {
				setShowResult(false)
				setShowLastStep(false)
			}

			setFormStep(step)
		}
	}, [questions])

	const handleSubmit = (values, actions) => {

		// console.log(values)

		actions.setSubmitting(true)
		verifyCase({ ...values, cid, tpl_id, gclid, fbclid, test_mode }).then(response => {

			if(response.data.success) {
				// changeStep(form_step + 1)
				setFormStep(total_steps)
				setShowResult(true)
				setShowLastStep(false)
				setIntakeStatus(response.data.status)
				
			}
			actions.setSubmitting(false)
		}).catch(error => {
			actions.setSubmitting(false)
		})
	}

	const displayErrorMessage = () => {
		return(
			<div className="bg-red border border-red rounded text-white text-sm p-4 flex justify-between">
  				<div>
				    <div className="flex items-center">
			      		<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" viewBox="0 0 20 20" fill="currentColor">
					        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
			      		</svg>

			      		<p><span className="font-bold">Error:</span>No Case Found!</p>
				    </div>
			  	</div>
			</div>
		)
	}

	const showResultHeading = () => {
		if(intakeStatus === 'QUALIFIED') {
			return <h3 className='mb-6 text-white text-2xl font-medium'>{ qualifiedContent.title }</h3>
		}

		if(intakeStatus === 'DISQUALIFIED') {
			return <h3 className='mb-6 text-white text-2xl font-medium'>{ disqualifiedContent.title }</h3>
		}

		if(intakeStatus === 'HOLD') {
			return <h3 className='mb-6 text-white text-2xl font-medium'>{ holdContent.title }</h3>
		}
	}

	const showResultContent = () => {
		if(intakeStatus === 'QUALIFIED') {
			return (
				<>
					<p className="text-base font-normal leading-7 text-white mb-3">{ qualifiedContent.message }</p>	
				</>
			)
		}

		if(intakeStatus === 'DISQUALIFIED') {
			return (
				<>
					<p className="text-base font-normal leading-7 text-white mb-3">{ disqualifiedContent.message }</p>
				</>
			)
		}

		if(intakeStatus === 'HOLD') {
			return (
				<>
					<p className="text-base font-normal leading-7 text-white mb-3">{ holdContent.message }</p>
				</>
			)
		}
	}

	const restartScreening = useCallback(() => {
		setFormStep(1)
		setShowLastStep(false)
		setShowResult(false)
		setOpenMessageModal(false)
		setOpenThankyouModal(false)
		setshowOtherAreaStep(false)
		setTerminateScreening(false)
		
		if(formikRef.current) {
			formikRef.current.resetForm()	
		}
		
	}, [])

	const showMessageModal = () => {
		setOpenMessageModal(true)
	}
	const closeMessageModal = useCallback(() => {
		setOpenMessageModal(false)
	}, [])

	const notifyMessageSent = useCallback(() => setOpenThankyouModal(true), [])

	const closeThankyouModal = useCallback(() => {
		setOpenThankyouModal(false)
		restartScreening()
	}, [restartScreening])

	const closeSignupSuccessModal = useCallback(() => {
		setOpenSignupSuccessModal(false)
	}, [])

	const provideOtherLawAreaOption = useCallback(() => setshowOtherAreaStep(true), [])
	const abortScreening = useCallback(() => {
		setShowResult(true)
		setShowLastStep(false)
		setIntakeStatus('DISQUALIFIED')
		setTerminateScreening(true)
	}, [])

	const signup = () => {
		if(signup_url) {
			setSubmitSignup(true)
			window.top.location.href = signup_url
		}
	}

	const showResultActionButton = () => {
		if(intakeStatus === 'QUALIFIED') {
			return (
				<button type="button" onClick={signup} disabled={submitSignup} className='next-btn !bg-white rounded-[12px] font-normal text-base leading-5 text-black p-4 w-full'>
					{!submitSignup &&
						<>
							Hire Our Firm Now
						</>
					}

					{submitSignup &&
						<>
							Processing <svg aria-hidden="true" className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/></svg>
    					<span className="sr-only">Loading...</span>
						</>	
					}
				</button>
			)
		}

		if(!terminateScreening && (intakeStatus === 'DISQUALIFIED' || intakeStatus === 'HOLD')) {
			return (
				<button onClick={showMessageModal} type="button" className='next-btn !bg-white rounded-[12px] font-normal text-base leading-5 text-black p-4 w-full'>Leave a Message</button>
			)
		}
	}

	const sendMessage = useCallback((message) => {
		const id = lead.uuid
		// console.log(id)
		return contactAdmin(id, message) 
	}, [contactAdmin, lead.uuid])

	const showForm = () => {
		if(!cid || !tpl_id) {
			return displayErrorMessage()
		}

		return (
			<>
				{!showResult &&
					<Formik innerRef={(f) => (formikRef.current = f)} enableReinitialize={false} initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
						{(props) => (
							<Form>
								<div className='block bg-transparent pt-[0px]  pb-0 px-0 rounded-2xl !shadow-sm'>
									
									<div className="block mb-1 relative z-50 !bg-grey-300 pt-[26px] pb-2 px-5 rounded-[14px] !shadow-sm border-[2px] border-border-grey bg-dropFilter">
										{!showLastStep && !showOtherAreaStep && questions.filter(item => item.id === question.id).map(filteredQuestion => (
											<Question {...props} key={`${filteredQuestion.id}-question`} {...filteredQuestion}  />
										))}

										{showLastStep &&
											<GetResultStep {...props} states={states} />
										}

										{showOtherAreaStep &&
											<OtherAreaStep  />
										}

										{!showLastStep && !showOtherAreaStep && form_step !== total_steps &&
											<NextBtn {...props} { ...question }  step={form_step} changeStep={changeStep} provideOtherLawAreaOption={provideOtherLawAreaOption} abortScreening={abortScreening}  />
										}

										{showLastStep && !showOtherAreaStep &&
											<ResultBtn {...props} />	
										}
									</div>

									{!showLastStep && !showResult &&
										<Badges />
									}

								</div>
							</Form>
						)}
					</Formik>
				}

				{showResult &&
					<>
						
						<div className='block mb-2.5 !bg-grey-300 pt-[26px] pb-2 px-5 rounded-[14px] !shadow-sm border-[2px] border-border-grey bg-dropFilter'>
							<div className='block'>
								{ showResultHeading() }

								{ showResultContent () }
							</div>

							{ showResultActionButton() }
						</div>
					</>
				}

				<MessageModal show={openMessageModal} handleClose={closeMessageModal} sendMessage={sendMessage} notifyMessageSent={notifyMessageSent} />
				<ThankyouModal show={openThankyouModal} handleClose={closeThankyouModal} />
				<SignupSuccessModal show={openSignupSuccessModal} handleClose={closeSignupSuccessModal} />
			</>
		)
	}

	const showLoader = () => {
		return (
			<>
				<div className="loadingDiv"></div>
			</>
		)
	}

	return (
		<>	
			<Layout>
				<div className='block'>
					
					{!isPageLoading &&
						<>
							<ResetBtnGroup progress_percent={progress_percent} isStepSkipped={isStepSkipped} step={form_step} changeStep={changeStep} showResult={showResult} restartScreening={restartScreening} showOtherAreaStep={showOtherAreaStep} terminateScreening={terminateScreening} />
							{ showForm() }
						</>
					}

					{isPageLoading &&
						showLoader()
					}

				</div>
			</Layout>
		</>
	)


}

export default memo(Screening)